define ['./acceptApplicationModal.css'], () ->
  ($scope, $uibModalInstance, RentappService, $http, RENTAPPLICATION_API_URL, Flash, $rootScope) ->
    $scope.theme_color = $rootScope.THEME_COLOR
    $scope.acceptApplication = (application, with_email, acceptance_email_subject, acceptance_email_body, cc_self) ->
      $http.post "#{RENTAPPLICATION_API_URL}/api/v1/application/#{application.id}/accept_application/",
        with_email:               with_email,
        acceptance_email_subject: acceptance_email_subject
        acceptance_email_body:    acceptance_email_body
        application_id:           application.id
        cc_self:           cc_self
      .then ->
        $uibModalInstance.close()
      .catch (r) ->
        if r.status = 400
          Flash.create("danger", r.data.error)
        else
          Flash.create("danger", 'Unfortunately, an error has occured in processing this request. Please try again.')
      .then () ->
        $scope.accept_application_processing = false;



// WEBPACK FOOTER //
// ./directives/acceptRejectApplication/acceptApplication/acceptApplicationModal/acceptApplicationModal.coffee